import { z } from 'zod';
import { DashboardNavSectionType } from '../../types';

const sidebarSectionSchema = z.object({
  isExpanded: z.boolean(),
});

// Define the schema for the dashboard sidebar settings
// NOTE: This schema should be extended in a backward compatible way because the values come from serialized JSON.
export const dashboardSidebarSettingSchema = z.object({
  [DashboardNavSectionType.Favorite]: sidebarSectionSchema.optional(),
  [DashboardNavSectionType.My]: sidebarSectionSchema.optional(),
  [DashboardNavSectionType.Published]: sidebarSectionSchema.optional(),
  [DashboardNavSectionType.Shared]: sidebarSectionSchema.optional(),
});

export type DashboardSidebarSetting = z.infer<
  typeof dashboardSidebarSettingSchema
>;
